module.exports = __webpack_public_path__ + "media/images/ir/common/footer_l-img-032b949ff45a5d8d7969e6b861c37fa1.svg";